import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { useNavigate } from 'react-router-dom';
import NavigationBar from '../NavigationBar';
import { renderPagination, PartyTable, renderAdvancedPagination } from '../utilities';
import axios from '../axios';
import { useManageTable, ManageSearch, TableMeta, runAction } from './manageDataShared';

const PARTY_FIELDS = ['PartyName', 'ContactNo', 'Address', 'TeamName', 'Currency', 'PaymentType', 'BillTallyName', 'PiTallyName'];

function Manage_party() {
  const navigate = useNavigate();
  const { data, currentPage, setCurrentPage, totalPages, totalRows, search, setSearch, loading, reload } = useManageTable('get_manage_party_table');

  const handleDeleteParty = async (entry) => {
    const ok = await runAction(
      () => axios.delete(`${window.backendUrl}/delete_manage_party/${entry['PartyID']}`),
      `${entry['PartyName']} deleted`,
      'Could not delete the party.'
    );
    if (ok) reload();
  };

  return (
    <>
    <NavigationBar />
    <Container fluid >
    <Row className='align-items-center' style={{margin:'20px 8px 0'}}>
      <Col xs='auto'>
        <h3 style={{margin:'0'}}>Manage Party</h3>
      </Col>
      <Col xs='auto'>
        <Button variant="primary" onClick={() => navigate('/add-new-party')}>
          <i className="fa fa-plus" aria-hidden="true" style={{marginRight:'6px'}}></i>Add New Party
        </Button>
      </Col>
      <Col className='d-flex justify-content-end'>
        {renderPagination({ totalPages, currentPage, setCurrentPage })}
        {renderAdvancedPagination({ totalPages, currentPage, setCurrentPage })}
      </Col>
    </Row>
    <Row>
        <Col style={{margin:'14px 20px 20px'}}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <TableMeta totalRows={totalRows} search={search.trim()} loading={loading} />
            <ManageSearch value={search} onChange={setSearch} placeholder="Search party, contact, team, tally name..." />
          </div>
          <Table striped bordered hover className={loading && data.length ? 'ft-loading' : undefined}>
              <thead>
                  <tr>
                  <th>SL</th>
                  <th>Company</th>
                  <th>Contact No</th>
                  <th>Address</th>
                  <th>Team</th>
                  <th>USD / BDT</th>
                  <th>Payment Type</th>
                  <th>Tally Name - Bill</th>
                  <th>Tally Name - PI</th>
                  <th>View, Edit or Delete Party</th>
                  </tr>
              </thead>
              <tbody>
                  {data.length ? (
                    <PartyTable
                      currentPage={currentPage}
                      data={data}
                      handleDeleteParty={handleDeleteParty}
                      fields={PARTY_FIELDS}
                    />
                  ) : (
                    <tr className="ft-empty-row">
                      <td colSpan={PARTY_FIELDS.length + 2}>
                        <i className={`fa ${loading ? 'fa-circle-o-notch fa-spin' : 'fa-inbox'}`} aria-hidden="true"></i>
                        {loading ? 'Loading…' : search.trim() ? `No parties match “${search.trim()}”.` : 'No parties yet.'}
                      </td>
                    </tr>
                  )}
              </tbody>
          </Table>
        </Col>
    </Row>
    </Container>
    </>
  )
}

export default Manage_party
